export enum ItemPriceType {
        PublicPrice = 1,
        XFactorPrice = 2,
        TenderPrice = 3,
        ExportPrice = 4,
        AveragePrice = 5
}
